import AccordionContainer from "../../../Components/UiKits/Accordion/AccordionContainer";

const Accordion = () => {
  return <AccordionContainer />;
};

export default Accordion;
